import { render } from "./Atlas.vue?vue&type=template&id=23dc5465&scoped=true"
import script from "./Atlas.vue?vue&type=script&lang=js"
export * from "./Atlas.vue?vue&type=script&lang=js"

import "./Atlas.vue?vue&type=style&index=0&id=23dc5465&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dc5465"]])

export default __exports__